import styled from "styled-components";

type ContentType = {
    background: string;
    border: string;
};

type ContainerType = {
    heightShowingHeaderInfo: number;
};

type IconOpsType = {
    color: string;
}

type TextType = {
    color: string;
}

export const Container = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  height: calc(100vh - 111px - ${props => `${props.heightShowingHeaderInfo}px`});
  overflow: hidden;
`;
export const TextError = styled.span<IconOpsType>`
  font-size: 12px;
  color: ${props => props.color};
  padding: 0 0 0 3px;
`;
export const Content = styled.div<ContentType>`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid ${props => props.border};
`;
export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex: 1;
  overflow: auto;
`;

export const ContentButton = styled.div`
    display: flex;
    height: 45px;
    width: 210px;
    margin-top: 10px;
`;
export const ContainerButtons = styled.div`
    display: flex;
    flex-direction: row;
`;
